export default "__VITE_ASSET__BStcSCIQ__"